import { Observable } from "rxjs";

export interface Lead {
  first_name: string;
  last_name?: string;
  full_name?: string;
  nome_e_cognome?: string;
  name?: string;
  surname?: string;
  phone:string;
  phone_number?:string;
  numero_di_telefono?:string;
  email:any;
  'e-mail'?:string;
  sentToBuyer?: boolean;
  needToSend?: boolean;
  id?: string;
  offerId?: any;
  offer_id?:any;
  response?:string;
  time?: any;
}

export abstract class LeadData {
  abstract getLeads(pagination, filter, order);
  abstract getLead(id: string);
  abstract sendLead(id: string);
}
